export const verifyDefaultPractice = (practice: string) => {
  const str = practice;
  const arr = str.split(",");
  if (arr.length > 1) {
    const index = str.split(",").indexOf("all");
    if (index > -1) {
      return str.split(",").filter(function(value, index, arr) {
        return value !== 'all';
      });
    }
  }
  return str.split(",");
}

export const findPractice = (arr: Array<any>, value: string) => {
  let result;
  arr.forEach((o:any) => {
    if (o.practiceDBName === value|| o.practiceName === value 
      ||o.practiceabbr === value || o.practice === value) {
      result = o;
      return true;
    }
  });
  return result;
}

export const capitalizeFirstLetters = (s: string, n:number) => {
  if (s === 'referout'){
    return `Referal Out: ${n}`;
  } else if (s === 'referin') {
    return `Referal In: ${n}`;
  } else {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  
}

export const capitalizeFirstLetter = (s?: string | null) => {
  if (s === undefined || s === null) {
    return '';
  } else {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
}

export const isBlankNullOrUndefined=(value:any)=>{
  if(value === '' || value ===undefined || value === null || value === {}) {
    return true
  } else {
    return false
  }
}


